import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ViewModeOption } from '../../../cross-team-shared/toolbars/layer-settings/layer-view-settings.component';

@Component({
  selector: 'h3-point-cloud-layer-view-settings',
  templateUrl: './point-cloud-layer-view-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
/** @deprecated used for old projects without objects */
export class PointCloudLayerViewSettingsComponent {
  viewModeOptions: ViewModeOption[] = [
    { viewMode: 'all', tooltip: 'All' },
    { viewMode: 'selected', tooltip: 'Selected' },
    { viewMode: 'none', tooltip: 'None' },
  ];
}
